import { render } from "./contact.vue?vue&type=template&id=3f64f108&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=3f64f108&lang=css"
import "./contact.vue?vue&type=style&index=1&id=3f64f108&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f64f108"]])

export default __exports__